import { Row, Table, Modal, Space, Button, Breadcrumb } from 'antd'
import { useRequest } from 'ahooks'
import React, { memo, useState } from 'react'
import classnames from 'classnames'
import { loadDimension, deleteDimensionUnit } from '@/services/dimension/dimension.service'
import { Link, useParams } from 'react-router-dom'
import { Dimension } from '@/services/dimension/dimension.model'
import { PlusOutlined } from '@ant-design/icons'
import DimensionForm from './DimensionForm'
import CreateEditUnit from './CreateEditUnit'

const DimensionItem = memo(() => {
  const { id } = useParams()
  const isCreate = !id
  const [dimension, setDimension] = useState<Dimension.Info>()

  const { refresh: refreshDimension } = useRequest(() => loadDimension(id), {
    ready: !!id,
    onSuccess: (data) => {
      setDimension(data)
    }
  })

  const columns = [
    { title: 'Code', dataIndex: 'code' },
    { title: 'Description', dataIndex: 'description' },
    { title: 'Factor', dataIndex: 'factor' },
    { title: 'Offset', dataIndex: 'offset' },
    {
      title: 'Action',
      dataIndex: '',
      render: (_, record: Dimension.Unit) => (
        <Space>
          <CreateEditUnit
            trigger={<a>Edit</a>}
            dimension={dimension!}
            unit={record}
            onSuccess={() => refreshDimension()}
          />
          <a
            onClick={() => {
              Modal.confirm({
                content: 'Are you sure to delete?',
                onOk: async () => {
                  await deleteDimensionUnit(dimension!.id, record.id)
                  refreshDimension()
                }
              })
            }}
          >
            Delete
          </a>
        </Space>
      )
    }
  ]

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={'../'}>Dimensions</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item> {isCreate ? 'Create Dimensions' : 'Detail'} </Breadcrumb.Item>
      </Breadcrumb>

      <div className='mt-2'>
        <DimensionForm dimension={dimension} isCreate={isCreate} refreshDimension={refreshDimension} />
      </div>

      <Row justify={'end'}>
        <CreateEditUnit
          trigger={
            <Button type='primary' disabled={!dimension} icon={<PlusOutlined />}>
              Create Unit
            </Button>
          }
          dimension={dimension!}
          onSuccess={() => refreshDimension()}
        />
      </Row>

      <div className={classnames('mt-2')}>
        <Table
          title={() => <b>Units</b>}
          bordered
          size='small'
          dataSource={dimension?.units || []}
          rowKey={(record) => record.id}
          columns={columns}
        />
      </div>
    </div>
  )
})

export default DimensionItem
